export const ACCESSIBILITY_COLOR_MODES = {
  DEFAULT: 'default',
  MONOCHROME: 'monochrome',
  ENHANCED_CONTRAST: 'enhancedContrast',
  HIGH_CONTRAST: 'highContrast',
};

export const ACCESSIBILITY_THEME_BY_COLOR_MODE = {
  [ACCESSIBILITY_COLOR_MODES.DEFAULT]: {
    name: 'Default',
    tName: 'default',
    value: {
      background: '#0b1826',
      base: '#222a2d',
      primaryShadow: '#1e374f',
      primary: '#325277',
      primaryHighlight: '#436c9a',
      primaryForeground: '#ffffff',
      primaryHighlightForeground: '#ffffff',
      fontColor: '#fff',
      divider: '#718096',
    },
  },
  [ACCESSIBILITY_COLOR_MODES.MONOCHROME]: {
    name: 'Monochrome',
    tName: 'greyscale',
    value: {
      background: '#000000',
      base: '#111111',
      primaryShadow: '#222222',
      primary: '#333333',
      primaryHighlight: '#444444',
      primaryForeground: '#ffffff',
      primaryHighlightForeground: '#ffffff',
      fontColor: '#fff',
      divider: '#8a8a8a',
    },
  },
  [ACCESSIBILITY_COLOR_MODES.ENHANCED_CONTRAST]: {
    name: 'Enhanced Contrast',
    tName: 'enhanced-contrast',
    value: {
      background: '#050b13',
      base: '#172033',
      primaryShadow: '#0f1724',
      primary: '#214f78',
      primaryHighlight: '#dbeafe',
      primaryForeground: '#ffffff',
      primaryHighlightForeground: '#0b1220',
      fontColor: '#f8fafc',
      divider: '#93a4b8',
    },
  },
  [ACCESSIBILITY_COLOR_MODES.HIGH_CONTRAST]: {
    name: 'High Contrast',
    tName: 'high-contrast',
    value: {
      background: '#000000',
      base: '#000000',
      primaryShadow: '#000000',
      primary: '#ffff00',
      primaryHighlight: '#00ffff',
      primaryForeground: '#000000',
      primaryHighlightForeground: '#000000',
      fontColor: '#ffffff',
      divider: '#ffffff',
    },
  },
};
